module.exports = __webpack_public_path__ + "static/media/logo-punto-seguido-small.f26d2e2c.svg";